import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/redux";
import { isAdminSelector } from "../../../store/slices/authSlice";

interface AdminRouteProps {
  children: React.ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const isAdmin = useAppSelector(isAdminSelector);

  if (!isAdmin) {
    return <Navigate to="/not-found?variant=access-denied" replace />;
  }

  return children;
};

export default AdminRoute;
